import React, { useRef } from 'react';
import Loader from '../../../components/Common/Loader';
import { PageDetailsModel } from '../../../interfaces/common.interface';
import { SecureImg } from '../../../components/Common/SecureImage';

interface ModalComponentProps {
  modalOpen: boolean;
  selectedPage: PageDetailsModel | null;
  bookUpdateLoader: boolean;
  createImageLoader: boolean;
  handleUpdateBook: () => void;
  handleRecreateImage: (bookId: string, pageIndex: number) => void;
  closeModal: () => void;
}

const ModalComponent: React.FC<ModalComponentProps> = ({
                                                         modalOpen,
                                                         selectedPage,
                                                         bookUpdateLoader,
                                                         createImageLoader,
                                                         handleUpdateBook,
                                                         handleRecreateImage,
                                                         closeModal
                                                       }: ModalComponentProps) => {
  const textRef = useRef<HTMLTextAreaElement>(null);
  const sceneRef = useRef<HTMLTextAreaElement>(null);

  return (
    <div
      className={`relative z-10 ${modalOpen ? 'block' : 'hidden'}`}
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="fixed inset-0 bg-gray-800 bg-opacity-75 transition-opacity"></div>
      <div className="fixed inset-0 z-10 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-8 md:p-4 text-center">
          <div
            className="relative transform overflow-hidden rounded-lg bg-storytan px-8 pb-4 pt-5 text-left shadow-xl transition-all sm:w-full sm:max-w-6xl">
            {/* Content of the modal */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="mt-2">
                <h3 className="text-sm text-gray-500 font-bold">PAGE TEXT</h3>
                <textarea
                  ref={textRef}
                  defaultValue={selectedPage?.text}
                  className="h-24 md:h-96 text-lg md:text-2xl w-full p-4 border-gray-400 border-2 text-gray-800"
                />
              </div>
              <div className="mt-2">
                <SecureImg
                  storageSrc={selectedPage?.imageURLwebp || selectedPage?.imageURL}
                  alt="Page"
                  className="mx-auto mt-4 w-48 md:w-96 h-48 md:h-96"
                />
              </div>
              <div className="mt-2">
                <h3 className="text-sm text-gray-500 font-bold">PROMPT FOR IMAGE GENERATION </h3>
                <textarea
                  ref={sceneRef}
                  defaultValue={selectedPage?.scene}
                  className="h-24 md:h-96 text-lg md:text-2xl w-full p-4 border-gray-400 border-2 text-gray-800"
                />
              </div>
            </div>
            <div className="float-right flex gap-2 mt-5 sm:mt-6">
              <button
                type="button"
                className="capitalize  flex items-center justify-center rounded-md border border-transparent bg-storyblue px-4 py-2 text-base  text-white shadow-sm"
                onClick={handleUpdateBook}
                disabled={bookUpdateLoader}
              >
                Update Text
                <Loader loader={bookUpdateLoader} />
              </button>

              <button
                type="button"
                className="capitalize flex items-center justify-center rounded-md border border-transparent bg-storyblue px-4 py-2 text-base   text-white shadow-sm"
                onClick={() => handleRecreateImage(selectedPage?.bookId!, selectedPage?.pageIndex!)}
                disabled={createImageLoader}
              >
                New Image
                <Loader loader={createImageLoader} />
              </button>
              <button
                type="button"
                className="capitalize inline-flex justify-center rounded-md border border-transparent bg-storyblueSecondLightText px-4 py-2 text-base   text-white shadow-sm"
                onClick={() => closeModal()}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalComponent;
